import Button from '@mui/material/Button';
import React from 'react';
import {Trans} from 'react-i18next';

import {CONTACT_SALES_URL} from '@explorer/constants';

const ContactSalesButton = props => (
  <Button
    variant="contained"
    color="primary"
    data-qe="contact-sales-button"
    href={CONTACT_SALES_URL}
    target="_blank"
    rel="noreferrer noopener"
    {...props}
  >
    <Trans i18nKey="common:contactSales" />
  </Button>
);

export default ContactSalesButton;
